import { FlexContext } from "./flex-context";
import { FlexSectionController } from "./flex-section-controller";
import { isSectionEmbedded } from "./utils";

const createSectionInstanceData = (controller: FlexSectionController, values: any, initialData: any) => {
	const fieldData = controller.fieldControllers.reduce(
		(a, f) => ({
			...a,
			[f.schema.attribute.identifier]: f.mapFormValue(values[f.schema.attribute.identifier], initialData),
		}),
		{} as any
	);
	return { ...aggregateSections(controller.sectionControllers, values, initialData), ...fieldData };
};

const createSectionData = (controller: FlexSectionController, values: any, initialData: any): any => {
	const sectionContainer = isSectionEmbedded(controller.schema) ? values : values[controller.schema.localizableKey];
	if (!sectionContainer) {
		return null;
	}

	const sectionValue = controller.schema.isArray
		? (sectionContainer as Array<any>).map((e) => createSectionInstanceData(controller, e, initialData))
		: createSectionInstanceData(controller, sectionContainer, initialData);

	return isSectionEmbedded(controller.schema) ? sectionValue : { [controller.schema.localizableKey]: sectionValue };
};

const aggregateSections = (controllers: Array<FlexSectionController>, values: any, initialData: any) => {
	return controllers.reduce((a, c) => ({ ...a, ...createSectionData(c, values, initialData) }), {} as any);
};

export const createSubmittedFormData = (context: FlexContext, values: any, initialData: any): any => {
	return aggregateSections(context.sectionControllers, values, initialData);
};
